import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import PropTypes from 'prop-types';
import { useLocation } from '@reach/router';
import queryString from 'query-string';

const COOKIE_IS_HEADER_HIDDEN = 'header_hidden';

export const QUERY_PARAM_KEYS = {
  HIDE_HEADER: 'hideHeader',
  MESSAGE: 'message',
};

export const ThemeContext = React.createContext({
  hideHeader: false,
});

export const ThemeContextProvider = ({ children }) => {
  const [hidden, setHidden] = useState(false);

  const location = useLocation();

  const parsedQuery = queryString.parse(location.search);

  useEffect(() => {
    const cookies = new Cookies();
    let isHeaderHidden = cookies.get(COOKIE_IS_HEADER_HIDDEN);

    let shouldUpdateCookies = false;

    if (!parsedQuery[QUERY_PARAM_KEYS.MESSAGE]) {
      shouldUpdateCookies = true;
    }

    if (shouldUpdateCookies) {
      isHeaderHidden = !!parsedQuery[QUERY_PARAM_KEYS.HIDE_HEADER];

      if (isHeaderHidden) {
        cookies.set(COOKIE_IS_HEADER_HIDDEN, 'yes', {
          maxAge: 365 * 3600 * 24,
        });
      } else {
        cookies.remove(COOKIE_IS_HEADER_HIDDEN);
      }
    }

    setHidden(isHeaderHidden);
  }, []);

  return (
    <ThemeContext.Provider
      value={{
        hideHeader: hidden,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

ThemeContextProvider.propTypes = {
  children: PropTypes.node,
};
